import { render, staticRenderFns } from "./otodetlawadv.vue?vue&type=template&id=64017e9d&scoped=true&"
import script from "./otodetlawadv.vue?vue&type=script&lang=js&"
export * from "./otodetlawadv.vue?vue&type=script&lang=js&"
import style0 from "./otodetlawadv.vue?vue&type=style&index=0&id=64017e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64017e9d",
  null
  
)

export default component.exports